import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Correction pour le navigateur in-app de Facebook qui ajoute ?fbclid=...
// Cela peut causer des problèmes de routage (page blanche)
if (window.location.search.includes('fbclid=')) {
  // On note que cela vient de Facebook pour les stats
  sessionStorage.setItem('analytics_pending_source', 'facebook');

  const newUrl = new URL(window.location.href);
  newUrl.searchParams.delete('fbclid');
  window.history.replaceState({}, document.title, newUrl.toString());
}

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
